import React,{useEffect,useState} from 'react';
import './SummaryScreen.css';
import Spinner from './../Spinner';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { resetStep } from '../../store/reducers/flowStepReducer';
import ProceedButton from '../Multiple/ProceedButton';
import { fetchPlanDetails } from '../../store/reducers/priceReducer';

const SummaryScreen = ({ amount, onPay }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const reduxFormData = useSelector((state) => state.profileList.formData);
    const priceListState = useSelector(state => state.priceList || []);
    const { apiResponse, loading } = priceListState;
    const priceData = apiResponse?.data || {};
    const [hasUpdatedProfile, setHasUpdatedProfile] = useState(false);

    console.log(" ",priceData);
    console.log("SummaryScreen apiResponse",apiResponse);

    const vehicleTypeId = localStorage.getItem('vTypeId');

    // Local state to hold updated form data
    const [formSubmittedData, setFormSubmittedData] = useState(reduxFormData);

    console.log("SummaryScreen vehicleTypeId",vehicleTypeId);

    useEffect(() => {
      if (vehicleTypeId) {
        dispatch(fetchPlanDetails(vehicleTypeId)); // Dispatch action with vehicle_type_id
      }
    }, [dispatch, vehicleTypeId]);

    useEffect(() => {

      if (hasUpdatedProfile || !priceData?.plan_name) return;

      const storedData = localStorage.getItem('customerProfile');
      if (storedData) {
        const parsedData = JSON.parse(storedData);
    
        if (
          (!parsedData.plan_name || parsedData.plan_name.length === 0) &&
          (!parsedData.vehicle_type || parsedData.vehicle_type.length === 0)
        ) {
          console.log("SummaryScreen customerProfile parsedData", parsedData);
          console.log("SummaryScreen customerProfile priceData", priceData);
          console.log("SummaryScreen customerProfile plan_name", priceData?.plan_name);
          console.log("SummaryScreen customerProfile plan_name2", priceData.plan_name);
            const updatedData = {
              ...parsedData,
              plan_name: priceData?.plan_name || '',
              vehicle_type: priceData?.vehicle_type?.vehicle_type_code ?? '',
            };
            console.log("SummaryScreen customerProfile updatedData", updatedData);
            // Update localStorage and state
            localStorage.setItem('customerProfile', JSON.stringify(updatedData));
            setFormSubmittedData(updatedData); // update local state
            setHasUpdatedProfile(true); // Prevent future updates
            console.log("SummaryScreen formSubmittedData",formSubmittedData);
        }else{
          setFormSubmittedData(parsedData); // retain to parsed data
          setHasUpdatedProfile(true); // Prevent future updates
        } 
      }

    }, [priceData]);

    console.log("SummaryScreen customerProfile",localStorage.getItem('customerProfile'));

    const handlePrevious = () => {
      localStorage.setItem('customerProfile', JSON.stringify(formSubmittedData));
        dispatch(resetStep());// Reset Redux state
        navigate('/customer-profile'); 
      };


    if (loading) {
        return (
            <Spinner />
          );
     }

  return (
    <div className="summary-screen">
      <div className="summary-header">
        <h4>Payment Details</h4>
      </div>
      <div className="payment-details">
      <div className="details-box">
        <div className="detail-row">
          <span>{priceData.plan_description}</span>
          <span>{priceData.amount_excl_tax}</span>
        </div>
        <div className="detail-row">
          <span>+GST (@{priceData.tax_percentage}%)</span>
          <span>{priceData.tax_amount}</span>
        </div>
        <div className="total-row">
          <strong>Total Payment</strong>
          <strong>{priceData.amount}</strong>
        </div>
        </div>
      </div>
      <ProceedButton 
        profileFormData={formSubmittedData} 
        amount={priceData.amount} 
        btnText={'Proceed to Pay'} />
    </div>
  );
};

export default SummaryScreen;
